const merchantIcon =
  "https://file-v2.uchoice.pro/ads/common/img/single.png?x-oss-process=style/webp";
const merchantIconActive =
  "https://file-v2.uchoice.pro/ads/common/img/single2.png?x-oss-process=style/webp";

const merchantManagementRoute: IRouteProps[] = [
  {
    path: "/merchant-management",
    name: "商家管理",
    meta: { icon: merchantIcon, activeIcon: merchantIconActive },
    routes: [
      {
        path: "/merchant-management/clueMerchant",
        name: "线索商户",
        component: "./merchant/clueMerchant"
      },
      {
        path: "/merchant-management/authMerchant/:id",
        name: "授权店铺",
        component: "./merchant/authMerchant",
        hideInMenu: true,
      },
      {
        path: "/merchant-management/supplier",
        name: "供应链管理",
        component: "./supplierManagement"
      },
      {
        path: "/merchant-management/supplier/add",
        name: "新增",
        component: "./supplierManagement/supplierAdd",
        hideInMenu: true
      },
      {
        path: "/merchant-management/supplier/edit/:supplierId",
        name: "编辑",
        component: "./supplierManagement/supplierAdd",
        hideInMenu: true
      },
      {
        path: "/merchant-management/supplier/shop/:supplierid&:name&:globalAccountId",
        name: "店铺",
        component: "./supplierManagement/shop",
        hideInMenu: true
      },
      {
        path: "/merchant-management/supplier/shop/pendingStore",
        name: "待绑定店铺",
        component: "./supplierManagement/shop/pendingStore",
        hideInMenu: true
      },
      {
        path: "/merchant-management/sample-quota",
        name: "样品额度",
        component: "./merchantManagement/sampleQuota"
      }
    ]
  }
];

export default merchantManagementRoute;
